<template>
<div id="experience">
    <!-- section title -->
    <h1>Experience</h1>
    <!-- section description -->
    <h2>Knowledge, like a sea, is boundless; only through hard study can one reach the destination.</h2>
    <!-- experience timeline -->
    <div class="timeline" v-animate-onscroll="'animated fadeIn'">
        <div 
            class="container" 
            v-for="(i, i_index) in eduHis" 
            :key="i_index"
        >
            <!-- starting year -->
            <h6>{{i.start}}</h6>
            <!-- content -->
            <div class="content">
                <!-- title -->
                <h5>{{i.title}}</h5>
                <!-- messages table -->
                <table>
                    <tbody v-for="(m, m_index) in i.msg" :key="m_index">
                        <td>{{m.title}} :</td>
                        <td>{{m.content}}</td>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name:'Experience',
    data() {
        return {
            eduHis:[
                {
                    title:'Ph.D. Computer Science and Engineering', start:'Aug. 2024 - Jul. 2028', 
                    msg:[
                        {title: 'University', content: 'The Chinese University of Hong Kong'},
                        {title: 'Superviser', content: 'Prof. Michael R. Lyu'},
                        {title: 'Exp Grad.', content: 'Jul. 2028'},
                    ],
                    location: 'cuhk'
                },
                {
                    title:'Research Visiting', start:'May 2024 - Jul. 2024', 
                    msg:[
                        {title: 'University', content: 'University of Warwick'},
                        {title: 'Superviser', content: 'Prof. Emma MacPherson'},
                    ],
                    location: 'cuhk'
                },
                {
                    title:'B.Sc. Computer Science', start:'Sep. 2020 - Jul. 2024', 
                    msg:[
                        {title: 'University', content: 'The Chinese University of Hong Kong'},
                        {title: 'College', content: 'Lee Woo Sing College'},
                        {title: 'Stream', content: 'ELITE Stream'},
                        {title: 'Honor', content: 'First Honor'},
                        {title: 'Major GPA', content: ' 3.80/4.00'},
                    ],
                    location: 'cuhk'
                },
            ]
        }
    },
}
</script>

<style scoped>
#experience{
    position: relative;
    width: 1000px;
    margin: 0px auto;
    background-repeat: no-repeat;
    background-size: cover;
    color: #494949;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
}

/* section description */
h2{
    height: 30px;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #EC624C;
    text-shadow: rgb(239, 166, 166) 0.1em 0.1em 0.2em
}


/* experience timeline styles */
.timeline {
    position: relative;
    width: 1000px;
    margin: 30px auto;
}

/* the actual timeline (the vertical ruler) */
.timeline::after {
    content: '';
    position: absolute;
    width: 4px;
    background-color: #494949;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -2px;
}

/* container around content */
.container {
    position: relative;
    width: 500px;
}
.container:nth-child(even){
    left: 50%;
}

/* the circles on the timeline */
.container::before{
    position: absolute;
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #363636;
    border: 4px solid #ffffff;
    z-index: 1;
}
.container:nth-child(odd)::before{
    right: -13.5px;
}
.container:nth-child(even)::before{
    left: -13.5px;
}

/* starting year */
.container h6{
    position: absolute;
    font-size: 20px;
    line-height: 30px;
}
.container:nth-child(odd) h6{
    right: -230px;
}
.container:nth-child(even) h6{
    left: -230px;
}

/* main content */
.content{
    width: 450px;
    /* height: 160px; */
    padding: 0 25px;
    margin-bottom: 40px;
    text-align: left;
}
.container:nth-child(odd) .content{
    text-align: right;
}

/* experience title */
.content h5{
    font-size: 20px;
    line-height: 30px;
}

/* content table */
.content table{
    display: inline-block;
    font-size: 15px;
    line-height: 30px;
    margin-left: -40px;
    
}
.content td:first-child{
    font-weight: bold;
    text-align: right;
}
.content td:last-child{
    text-align: left;
}

</style>